import createGlobalStore from "./create.global";
import GlobalStore from "./store.global";

export { GlobalStore, createGlobalStore };
